import styled, { css, keyframes } from 'styled-components';
import TickIcon from '../../icons/Tick';
import DownArrowIcon from '../../icons/downArrow';

export const TickIco = styled(TickIcon)``;

export const ChckAirln = styled.label`
  position: relative;
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  cursor: pointer;
  ${props =>
    props.paymentOption &&
    css`
      &&& {
        ${props => props.theme.alignItemsStart};
      }
    `}
`;

export const CheckBox = styled.span`
  position: relative;
  cursor: pointer;
  ${props => props.theme.flexCol};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyCenter};
  ${props =>
    props.cab &&
    css`
      &&& {
        width: 20px;
        height: 20px;
        border: 1.6px solid #647a97;
      }
    `}
  ${props =>
    props.radio &&
    css`
      &&& {
        border-radius: 50%;
      }
    `}
     ${props =>
    props.fareFamily &&
    css`
      &&& {
        width: 14px;
        height: 14px;
      }
    `}
`;

export const CheckCustom = styled.input`
  display: none;
  &:checked ~ ${CheckBox} {
    background-color: #0069e2;
    border-color: #0069e2;
  }
  ${props =>
    props.radio &&
    css`
      &:checked ~ ${CheckBox} {
        background-color: #2e69b3;
        border-color: #2e69b3;
      }
    `}
  &:checked ~ ${CheckBox} ${TickIco} {
    opacity: 1;
    transform: scale(1);
    transition: all 0.2s ease;
  }
  & ~ ${CheckBox} {
    border: 2px solid #0069e2;
    width: 22px;
    height: 22px;
    border-radius: 3px;
    background-color: #ffffff;
    transition: all 0.2s ease;
    left: 0;
  }
  & ~ ${CheckBox} ${TickIco} {
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
  }
`;

export const CustRad = styled.div`
  .lh1-5 {
    line-height: 1.5;
  }
  & [type='radio']:checked,
  & [type='radio']:not(:checked),
  .custCheck:checked,
  .custCheck:not(:checked),
  .custCheck1:checked,
  .custCheck1:not(:checked) {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  & [type='radio']:checked + label,
  & [type='radio']:not(:checked) + label {
    position: relative;
    padding-left: ${props => props.theme.spacing.custom(25)};
    cursor: pointer;
  }

  & [type='radio']:not(:checked) + label:before,
  & [type='radio']:checked + label:before {
    content: '';
    border: 2px solid #647a97;
    position: absolute;
    left: 0;
    top: -2px;
    width: 18px;
    height: 18px;
    border-radius: 100%;
  }

  & [type='radio']:checked + label:before {
    border-color: #2276e3;
  }

  & [type='radio']:checked + label:after,
  & [type='radio']:not(:checked) + label:after {
    content: '';
    width: 10px;
    height: 10px;
    background-color: #2276e3;
    position: absolute;
    top: 2px;
    left: 4px;
    border-radius: 100%;
    transition: all 0.2s ease;
  }

  & [type='radio']:not(:checked) + label:after,
  .custCheck:not(:checked) ~ .checkmark i {
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
  }

  & [type='radio']:checked + label:after,
  .custCheck:checked ~ .checkmark i,
  .custCheck1:checked ~ span {
    opacity: 1;
    transform: scale(1);
    transition: all 0.2s ease;
  }
`;

export const Check20 = styled.input`
  width: 20px;
  height: 20px;
`;

export const SelectBoxLbl = styled.label`
  position: relative;
  margin: 0 0.5rem;
`;

export const DownArrIcon = styled(DownArrowIcon)`
  position: absolute;
  top: 50%;
  right: 3px;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const CustSelectB = styled.select`
  padding: ${props => props.theme.spacing.custom(5)} ${props => props.theme.spacing.custom(15)}
    ${props => props.theme.spacing.custom(5)} ${props => props.theme.spacing.custom(5)};
  border: none;
  outline: none;
  border-radius: 0.5em;
  appearance: none;
  background-color: #f3f8fd;
  option {
    font-weight: normal;
    color: #333333;
  }
`;

export const CustSelectTrvl = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  background: ${props => (props.disabled ? '#f0f0f0' : '#fff')}
    url('https://gos3.ibcdn.com/downArrow-1656566889.gif') no-repeat 94% 50% !important;
  padding: ${props => props.theme.spacing.custom(5)} ${props => props.theme.spacing.custom(25)}
    ${props => props.theme.spacing.custom(5)} ${props => props.theme.spacing.custom(5)};
  font-size: ${props => props.theme.font.custom(14)};
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 2px;
  line-height: 1.42857143;
  color: #555;
  ${props =>
    props.mobile &&
    css`
      width: 100%;
      opacity: 0;
    `}
  ${props =>
    props.error &&
    css`
      border-color: #e85c41;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
    `}
`;
export const CustIp = styled.div`
  font-size: 14px;
  height: 38px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 6px 12px;
`;
export const IpTxt = styled.input`
  font-size: ${props => props.theme.font.custom(14)};
  height: 38px;
  line-height: 1.42857143;
  color: #555;
  background-color: ${props => (props.disabled ? '#f0f0f0' : '#fff')};
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: ${props => props.theme.spacing.custom(6)} ${props => props.theme.spacing.custom(12)};
  ${props =>
    props.error &&
    css`
      border-color: #e85c41;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
    `}
  &:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  }

  &::-moz-placeholder {
    color: #999;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: #999;
  }

  &::-webkit-input-placeholder {
    color: #999;
  }
  ${props =>
    props.email &&
    css`
      padding-left: ${props => props.theme.spacing.custom(40)};
    `}
`;
export const CarrierLogo = styled.img`
  max-width: 100%;
  max-height: 30px;
  padding-right: ${props => props.theme.spacing.custom(10)};
`;

export const BkFltCrd = styled.div`
  ${props =>
    props.isCombinedView
      ? 'border-top: 1px solid rgb(216, 216, 216);'
      : css`
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
          margin-top: 20px;
          background-color: #ffffff;
          border-radius: 5px;
          border: 1px solid #e6e6e6;
        `}
`;

export const Wid13 = styled.div`
  width: 13%;
`;

export const Wid31 = styled.div`
  width: 31%;
`;

export const Wid25 = styled.div`
  width: 25%;
`;

export const Wid22 = styled.div`
  width: 22%;
`;

export const ReviewCntWrp = styled.div`
  margin: 0 auto;
  width: 90%;
`;
export const ReviewCntBox = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: ${props => props.theme.spacing.custom(10)} 0;
  position: relative;
`;

export const DtlSummary = styled.div`
  margin-right: 5px;
  font-size: ${props => props.theme.font.custom(12)};
  border-radius: 5px;
  color: #666;
  padding: ${props => props.theme.spacing.custom(5)} ${props => props.theme.spacing.custom(10)};
  border: 1px solid #e6e6e6;
`;

export const HeaderEdit = styled.span`
  color: #166bd3 !important;
  cursor: pointer;
`;

export const PlaceHolderShimmer = keyframes`{0% {background-position: -468px 0 } 100% {background-position: 468px 0 } }`;

export const AnimatedBackground = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${PlaceHolderShimmer};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  max-height: 96px;
  position: relative;
`;

export const Spinner = styled.div`
  font-size: ${props => props.theme.font.custom(6)};
  text-indent: -9999em;
  width: 4em;
  height: 4em;
  border-radius: 50%;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
  position: relative;
  animation: load3 1.4s infinite linear;

  transform: translateZ(0);
  overflow: hidden;
  &::before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &::after {
    background: #ff6d38;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const SpinnerLoader = styled.div`
  font-size: ${props => (props.Seat ? '3px' : '2px')} !important;
  text-indent: -9999em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: #2276e3;

  background: linear-gradient(to right, #2276e3 10%, rgba(255, 255, 255, 0) 42%);
  position: relative;

  animation: load3 1.4s infinite linear;

  transform: translateZ(0);
  overflow: hidden;
  top: ${props => (props.mapLoader ? '35rem' : '')};
  &:before {
    width: 50%;
    height: 50%;
    background: #2276e3;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &:after {
    background: ${props => (props.Seat ? '#dadee3' : '#ffffff')};
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  margin: auto;
  padding: 1.5rem;
`;

export const DotAnim = styled.div`
  span {
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    float: left;
    background-color: ${props => props.color || '#fff'};
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin-right: 5px;
  }
  span:nth-child(2) {
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    animation-delay: 0.4s;
  }
  @-webkit-keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
`;
